<template>
	<div class="meeting-calendar max-content" @click.capture="onWikiGuard">
		<banner :type="type" class="banner"></banner>
		<!-- <van-search v-model="keywords" placeholder="请输入关键词搜索会议" shape="round" @search="goSearch"/> -->
		<calendar ref="calendar" :month-meetings-count="monthMeetings.length" @changeMonth="getMonthMeetings"
			@changeDay="dateInRange" class="calendar"></calendar>
		<div class="meeting-container">
			<div class="meeting-list1 day-meetings" v-if="dayMeetings.length > 0">
				<div class="meeting-header">
					<h3 class="title">{{ selectedDateTitle }}</h3>
					<!-- <div class="header-right">
						<span class="collapse-btn" @click="dayListCollapsed = !dayListCollapsed">{{ dayListCollapsed ? '展开' : '收起' }}</span>
						<span class="meeting-number" v-if="dayMeetings.length > 0">{{ dayMeetings.length }} 场会议</span>
						<span class="meeting-number empty-tag" v-else>无</span>
					</div> -->
				</div>
				<div class="list-bg" v-show="!dayListCollapsed">
					<template>
						<div class="item day-item" v-for="(item, index) in dayMeetings" :key="index"
							@click="goDetail(item)">
							<div class="color-dot" :style="{ 'background-color': colors[item.color_index % 5] }"></div>
							<div class="content">
								<div class="name">{{ item.name }}</div>
								<div class="bottom">
									<p v-if="item.city">{{ item.province }} {{ item.city }}</p>
									<p v-else>{{ item.province }}</p>
								</div>
							</div>
						</div>
					</template>
					<!-- <div v-else class="empty">无</div> -->
				</div>
			</div>
			<div class="meeting-list1" v-if="monthMeetings.length > 0">
				<div class="meeting-header">
					<h3 class="title">当月会议</h3>
					<span class="meeting-number">{{ monthMeetings.length }}场会议</span>
				</div>
				<div class="item" v-for="(item, index) in monthMeetings" :key="index" @click="goDetail(item)">
					<!-- <span class="color-line" :style="{ 'background-color': colors[index % 5] }"></span> -->
					<div class="image">
						<img :src="item.banner" />
					</div>
					<div class="content">
						<div class="name">{{ item.name }}</div>
						<div class="bottom">
							<p v-if="item.city">地点：{{ item.province + " " + item.city }}</p>
							<p v-else>地点：{{ item.province }}</p>
							<div class="flex" style="justify-content: space-between;width: 100%;">
								<p>{{ item.start_at }}-{{ item.end_at }}</p>
								<div class="status"  :class="getMeetingStatus(item).cls">{{ getMeetingStatus(item).text
									}}</div>


							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabbar :active="index"></tabbar>
	</div>
</template>
<script>
import Calendar from '../components/Calendar'
import ItemBlock from '../components/ItemBlock'
import Banner from '../components/Banner'
import Tabbar from '../components/Tabbar'
import { MeetingMonth, MeetingsSearch } from '../../../config/interface.js'
import { Toast } from 'vant'
export default {
	components: {
		Calendar,
		ItemBlock,
		Banner,
		Tabbar,
	},
	data() {
		return {
			count: 0,
			calendar_active: 0,
			type: 12,
			index: 0,
			monthMeetings: [],  //本月会议
			monthMeetings2: [], //本月会议(未做处理的数据)
			dayMeetings: [],    //今日会议
			historyWords: [],      //历史搜索
			currentYear: new Date().getFullYear(),
			currentMonth: new Date().getMonth() + 1,
			currentDay: new Date().getDate(),
			keywords: '',
			loading: false,
			resultMeetings: [],
			colors: ['#4B85ED', '#FDA245', '#57C393', '#FF8288', '#C783FC'],
			selectedDateTitle: '当日会议',
			dayListCollapsed: false
		}
	},
	computed: {
		isWikiSource() {
			return this.$route.query.source === 'wiki' || this.$route.params.source === 'wiki'
		}
	},
	watch: {
		calendar_active(newValue, oldValue) {
			this.count <= 0 ? this.count++ : '';
			newValue == 0 && this.count == 1 ? this.getMonthMeetings(this.currentMonth, this.currentYear) : '';
		}
	},
	mounted() {
		this.calendar_active = this.$route.params.calendar_active ? this.$route.params.calendar_active : 0;
		this.calendar_active == 0 ? this.getMonthMeetings(this.currentMonth) : '';
		this.currentMonth = this.currentMonth < 10 ? '0' + this.currentMonth : this.currentMonth;
		this.currentDay = this.currentDay < 10 ? '0' + this.currentDay : this.currentDay;
		this.selectedDateTitle = `${parseInt(this.currentMonth, 10)}月${parseInt(this.currentDay, 10)}日 会议`;
		if (common.is_weixin()) {
			common.wxShare('会议日历@血管资讯', '血管外科领域最新会议一览', 'cdn.edstatic.com/203012120000/bca5bbcde6b65142646518943d71936a/2020/09/8e44215d-f687-4be7-8ced-81c3c880587a.png');
		}
	},
	methods: {
		onWikiGuard(e) {
			if (!this.isWikiSource) return
			e.stopPropagation()
			e.preventDefault()
			Toast('详情请跳转【血管资讯】公众号查看')
		},
		//当月会议
		getMonthMeetings(month, year) {
			this.$store.dispatch('isShowLoading', true);
			const url = MeetingMonth;
			const method = 'POST'
			let params = {
				month: month,
				year: year
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data1 = JSON.parse(JSON.stringify(res.data));
						let data2 = JSON.parse(JSON.stringify(res.data));
						data1.forEach((item, index) => {
							item._start = new Date(item.start_at.split(' ')[0]).getTime();
							item._end = new Date(item.end_at.split(' ')[0]).getTime();
							item.start_at = ((item.start_at.split(' ')[0]).split('-')).join('.');
							let end_at_arr = (item.end_at.split(' ')[0]).split('-');
							item.end_at = end_at_arr[1] + '.' + end_at_arr[2];
						})
						this.monthMeetings = data1;
						data2.forEach((item, index) => {
							item.start_at = item.start_at.split(' ')[0];
							item.end_at = item.end_at.split(' ')[0];
						})
						this.monthMeetings2 = data2;
						this.$refs.calendar.init(data2);
						this.dateInRange(this.currentYear + '-' + this.currentMonth + '-' + this.currentDay);

					}
					this.$store.dispatch('isShowLoading', false);
				})
		},
		//今日会议
		getDayMeetings(data) {
			data.start_at = ((data.start_at.split(' ')[0]).split('-')).join('.');
			let end_at_arr = (data.end_at.split(' ')[0]).split('-');
			data.end_at = end_at_arr[1] + '.' + end_at_arr[2];
			this.dayMeetings = data;
		},
		//判断一个日期是否在时间范围内
		dateInRange(day) {
			const [y, m, d] = (day || '').split('-');
			if (m && d) {
				this.selectedDateTitle = `${parseInt(m, 10)}月${parseInt(d, 10)}日 会议`;
			}
			this.dayMeetings = [];
			let timeStamp = new Date(day).getTime();
			let data = JSON.parse(JSON.stringify(this.monthMeetings2));    //深拷贝
			data.forEach((value, index) => {
				let startTime = value.start_at;
				let endTime = value.end_at;
				if (timeStamp >= new Date(startTime).getTime() && timeStamp <= new Date(endTime).getTime()) {
					value._start = new Date(value.start_at.split(' ')[0]).getTime();
					value._end = new Date(value.end_at.split(' ')[0]).getTime();
					value.start_at = ((value.start_at.split(' ')[0]).split('-')).join('.');
					let end_at_arr = (value.end_at.split(' ')[0]).split('-');
					value.end_at = end_at_arr[1] + '.' + end_at_arr[2];
					value.color_index = index
					this.dayMeetings.push(value)
				}
			})

		},
		goDetail(val) {
			if (this.isWikiSource) {
				Toast('详情请跳转【血管资讯】公众号查看')
				return
			}
			let id = val.id
			let buttons_count = val.buttons_count
			if (val.live_url) {
				window.location.href = val.live_url
				return;
			}
			if (buttons_count) {
				if (id == 286) {
					this.$router.push({
						path: '/CEC2022/index',
					})
				}
				else if (id == 348) {
					this.$router.push({
						path: '/CEC2023/index',
					})
				}
				else if (id == 399) {
					this.$router.push({
						path: '/CVSCF2023/index',
					})
				}
				else if (id == 483) {
					this.$router.push({
						path: '/XVC/index',
					})
				}
				else {
					this.$router.push({
						path: '/vascularNews/meeting/index',
						query: {
							meeting_id: id
						}
					})
				}
			}
			else {
				this.$router.push({
					path: '/vascularNews/meeting/live',
					query: {
						meeting_id: id
					}
				})
			}

		},
		getMeetingStatus(item) {
			const now = Date.now();
			const start = item._start || 0;
			const end = item._end || 0;
			if (now < start) return { text: '即将开始', cls: 'status-upcoming' };
			if (now > end) return { text: '已结束', cls: 'status-ended' };
			return { text: '进行中', cls: 'status-ongoing' };
		},
		goSearch() {
			if (this.keywords) {
				this.$router.push({
					path: '/vascularNews/search',
					query: {
						keywords: this.keywords
					}
				})
			}
		}
	}

}
</script>
<style lang="scss" sc>
.meeting-calendar {
	// background: linear-gradient(180deg, #f8f9fc 0%, #f0f2f7 100%);
	background: linear-gradient(180deg, #fde4e5, #fcf7f7 24%);
	min-height: 100vh;
	padding-bottom: 60px;

	.banner {
		background: transparent;

		img {
			margin: 10px 0 6px;
			border-radius: 12px;
			box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
			overflow: hidden;
		}
	}

	.name {
		letter-spacing: 0;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		line-height: 20px;
		color: #131313;
		font-size: 14px;
		font-weight: 500;
		line-clamp: 2;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.calendar {
		margin: 0 10px;
	}

	.van-tabs--line .van-tabs__wrap {
		border-bottom: 1px solid #e5e5e5;
	}

	.meeting-container {
		margin: 16px 10px 0;
	}

	.meeting-list1 {
		margin-top: 16px;

		.meeting-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			padding: 0 4px 12px;

			.title {
				color: #1f1f1f;
				font-size: 16px;
				font-weight: 600;
				letter-spacing: 0;
			}

			.header-right {
				display: flex;
				align-items: center;
				gap: 8px;
			}

			.collapse-btn {
				font-size: 13px;
				color: #8ab4f8;
				cursor: pointer;
			}

			.meeting-number {
				font-size: 13px;
				color: #5f6368;

				&.empty-tag {
					color: #9aa0a6;
				}
			}
		}

		.list-bg {
			border: 1px solid #e0e7f5;
			background: rgba(220, 232, 255, 0.3);
			border-radius: 16px;
			padding: 12px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
		}

		.empty {
			padding: 24px 0;
			text-align: center;
			color: #9aa0a6;
			font-size: 14px;
		}

		.item {
			display: flex;
			align-items: center;
			margin: 0 0 10px;
			padding: 12px;
			background: #ffffff;
			border-radius: 8px;
			box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
			cursor: pointer;

			&:last-child {
				margin-bottom: 0;
			}

			.color-line {
				width: 4px;
				border-radius: 999px;
				margin-right: 12px;
			}

			.status {
				font-size: 12px;
				// margin-top: 6px;


				&.status-upcoming {
					color: #1a73e8;
				}

				&.status-ongoing {
					color: #34a853;
				}

				&.status-ended {
					color: #9aa0a6;
				}
			}

			.color-dot {
				width: 8px;
				height: 8px;
				border-radius: 50%;
				margin-right: 12px;
				flex-shrink: 0;
			}

			img {
				width: 100%;
				border-radius: 8px;
				object-fit: cover;
			}

			.image {
				width: 34%;
				margin-right: 10px;
				// margin-left: 4%;
			}

			.content {
				flex: 1;
				min-width: 0;
				font-size: 14px;
				display: flex;
				flex-direction: column;
				justify-content: center;

				.name {
					font-weight: 600;
					color: #202124;
					margin-bottom: 4px;
					font-size: 12px;
					line-height: 15px;
				}

				.bottom {
					font-size: 12px;
					line-height: 18px;
					color: #5f6368;

					p {
						margin: 0;
					}
				}
			}
		}

	}

	.el-input__inner {
		border-radius: 30px;
	}
}

@media screen and (min-width: 768px) {
	.meeting-calendar {
		padding: 12px 14px 80px;

		.calendar {
			margin: 0 auto;
			max-width: 600px;
		}

		.meeting-container {
			max-width: 600px;
			margin: 16px auto 0;

			.list-bg {
				margin: 0 0 10px;
			}
		}
	}
}

.el-select-dropdown__item {
	max-width: 300px;
	display: inline-block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.el-select-dropdown {
	max-width: 340px;
}

.el-select .el-input.is-focus .el-input__inner {
	border-color: #d2020d !important;
}

.el-select .el-input__inner:focus {
	border-color: #d2020d !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Calendar/Calendar.vue